<template>
  <div class="flex-row h-full flex-y-center navbar">
    <!-- 系统标题 -->
    <logo :collapse="false" />
    <div class="flex-1-hidden flex-y-center">
      <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    </div>
    <div class="right-menu flex-row">
      <!-- 小铃铛 -->
      <el-badge v-if="0" class="cursor-pointer w-40">
        <span class="iconfont icon-xiazai" @click="toggleDownloadCenter" />
      </el-badge>
      <!--      <el-badge :value="99" class="cursor-pointer w-40" :max="99" @click="toggleNoticeCenter">-->
      <!--        <span class="iconfont icon-tongzhi" @click="toggleNoticeCenter" />-->
      <!--      </el-badge>-->
      <el-dropdown class="avatar-container flex-y-center" trigger="click">
        <div class="avatar-wrapper cursor-pointer">
          <img :src="avatar ? `${avatar}` : defaultAvatar" class="user-avatar" alt="用户头像" />
          <span class="user-name">{{ user.username }}</span>
          <em class="el-icon-caret-bottom"></em>
        </div>
        <el-dropdown-menu>
          <!-- <el-dropdown-item @click.native="forgotPassword">
            <em class="iconfont icon-yonghuzhongxin"></em>
            忘记密码
          </el-dropdown-item> -->
          <!-- <el-dropdown-item @click.native="setting = true">
            <span>布局设置</span>
          </el-dropdown-item> -->
          <el-dropdown-item divided @click.native="logout">
            <em class="iconfont icon-tuichu-"></em>
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-drawer custom-class="drawer-content" :visible.sync="isShowDownloadCenter" size="600px" append-to-body>
      <template #title>
        <span class="drawer-title">下载中心</span>
      </template>
      <Download-center :isShow="isShowDownloadCenter"></Download-center>
    </el-drawer>
    <!--    <el-drawer custom-class="drawer-content" :visible.sync="isShowNoticeCenter" size="600px" append-to-body>-->
    <!--      <template #title>-->
    <!--        <span class="drawer-title">消息中心</span>-->
    <!--      </template>-->
    <!--      <Message-center :isShow="isShowNoticeCenter"></Message-center>-->
    <!--    </el-drawer>-->
    <!-- <user-reset ref="userResetComponent"></user-reset> -->
  </div>
</template>

<script>
  import { mapActions, mapState } from 'pinia'
  import { pinias } from '@main/common/pinia'
  import DownloadCenter from '@main/modules/center/views/DownloadCenter.vue'
  // import MessageCenter from '@main/modules/center/views/MessageCenter.vue'
  import Logo from './SiderBar/Logo.vue'
  // import settings from '@main/common/pinia/setting'
  import Breadcrumb from './Breadcrumb/index.vue'

  const { settings, login } = pinias

  export default {
    components: {
      Breadcrumb,
      Logo,
      DownloadCenter
      // MessageCenter
    },
    data() {
      return {
        isShowDownloadCenter: false,
        isShowNoticeCenter: false
      }
    },
    computed: {
      ...mapState(settings, ['sidebar']),
      ...mapState(login, ['userName', 'avatar', 'user']),
      defaultAvatar() {
        return new URL('../../../common/assets/images/defaultavatar.png', import.meta.url).href
        // return `../../../common/assets/images/defaultavatar.png`
      }
    },
    methods: {
      ...mapActions(settings, ['setSidebarHide']),
      ...mapActions(login, ['LogOut']),
      // 进入消息通知
      logout() {
        this.$confirm('确定注销并退出系统吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.LogOut().then(() => {
            this.$router.push('/login')
          })
        })
      },
      forgotPassword() {
        console.log('forgotPassword');
        // this.$refs.userResetComponent.handleOpen();
      },
      toggleDownloadCenter() {
        this.isShowNoticeCenter = false
        this.isShowDownloadCenter = !this.isShowDownloadCenter
      },
      toggleNoticeCenter() {
        this.isShowDownloadCenter = false
        this.isShowNoticeCenter = !this.isShowNoticeCenter
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../common/assets/style/variables';

  .flex-1-hidden {
    overflow: hidden;
    flex: 1 1 0;
  }

  .flex-y-center {
    display: flex;
    align-items: center;
  }

  .navbar {
    box-shadow: 0 1px 2px #00152914;
  }

  .avatar-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;

    .user-name {
      font-size: 16px;
      font-weight: 500;
      margin-right: 8px;
      padding-left: 40px;
      color: #fff;
    }

    img.user-avatar {
      position: absolute;
      top: -8px;
      left: 12px;
      height: 33px;
      border-radius: 50%;
    }

    .el-icon-caret-bottom {
      font-size: 16px;
      color: #fff;
    }
  }

  ::v-deep .second-menu {
    display: inline-block;
    width: 2em !important;
    margin-right: 8px;
  }

  .el-dropdown-menu__item .iconfont {
    font-size: 18px;
    margin-right: 3px;
    vertical-align: middle;
  }

  .el-drawer__wrapper {
    top: 64px;
    height: calc(100% - 64px);

    .el-drawer__header {
      margin-bottom: 10px;
    }

    .drawer-title {
      font-size: 18px;
      font-weight: 500;
      color: $x-item-text-color;
    }
  }
</style>
<style>
  .w-40 {
    width: 40px;
  }

  .el-badge .el-badge__content.is-fixed {
    right: 30px;
  }

  span.iconfont.icon-taiyang {
    font-size: 21px;
  }

  span.iconfont.icon-tongzhi {
    font-size: 21px;
  }
</style>
